module.exports = __webpack_public_path__ + "img/Fotolia_106332295.d1752821.png";